import { useEffect, useState } from 'react';
import { Modal, Row, Col, Container, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AppStorage from '@randlabs/encrypted-local-storage';
import logo from '../assets/images/purrserlogo_new.png';

import { PASSWORD_KEY } from '../utils/constants';
import { FormButton } from '../components/commons/Buttons';

interface ModalProps {
  show: boolean | undefined;
  onHide(): void;
}

export const SignupModal: React.FC<ModalProps> = (props: ModalProps): JSX.Element => {
  const [error, setError] = useState('');
  // const validPassword = new RegExp('^(?=.*?[A-Za-z])(?=.*?[0-9]).{6,}$');

  function checkPwd(str: string) {
    if (str.length < 6) {
      return 'Password must be longer than 6 characters';
    } else if (str.length > 50) {
      return 'Password is too long (maximum 50 characters)';
    } else if (str.search(/\d/) === -1) {
      return 'Password must contain at least one number';
    } else if (str.search(/[a-zA-Z]/) === -1) {
      return 'Password must contain at least one letter';
      //eslint-disable-next-line
    } else if (str.search(/[^a-zA-Z0-9\!\@\#\$\%\^\&\*\(\)\_\+]/) !== -1) {
      return 'Password contains an invalid character';
    }
    return '';
  }

  const handleCreatePassword = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const initPassword = (e.currentTarget.elements[0] as HTMLInputElement).value;
    const confirmPassword = (e.currentTarget.elements[1] as HTMLInputElement).value;

    if (initPassword !== confirmPassword) {
      setError(`Passwords are not the same`);
      return;
    }

    const pwCheck = checkPwd(initPassword);

    if (pwCheck.length) {
      setError(pwCheck);
      return;
    }

    try {
      await AppStorage.createPassword(PASSWORD_KEY, confirmPassword);
    } catch (err) {
      console.error(err as Error);
    }

    props.onHide();
    return;
  };
  useEffect(() => {
    //
  }, [error]);

  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <Modal.Body style={{ borderTopRightRadius: '1rem', borderTopLeftRadius: '1rem' }}>
        <Container className="container-wrapper">
          <Row>
            <Col style={{ textAlign: 'center' }}>
              <div style={{ textAlign: 'center' }}>
                <h2> PURRSER </h2>
                <br />
                <i>"Purrfect the Purrses"</i>
              </div>
              <div style={{ textAlign: 'center' }}>
                <img height="150px" width="auto" id="circle-logo" src={logo} alt="local wallet" />
              </div>
              <h4 className="sub-header-text header-modal">Program Mission Statement </h4>
              <p>
                Organizing your accounts' assets on Algorand can be complicated and time consuming.
                Now assets can be swapped between all of your connected wallets with opt ins,
                transfers, and opt outs being largely automated.
              </p>
              <p />
              <h4 className="sub-header-text header-modal">New Account </h4>
              <p>
                This account and its password are stored within your browser. Loss of your password
                or device will cause the local app data to not be recoverable as Purrser does not
                store this data. Your accounts will still be safe on blockchain and on your
                connected web wallets, but you will have to create a new Purrser account and
                reconnect and import your wallets again.
              </p>
              <p />
            </Col>
            <p />
            <Row>
              <Form onSubmit={handleCreatePassword}>
                <Col className="container-label mt-1">
                  <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label bsPrefix="" aria-label="Enter password">
                      <div className="label-text" style={{ fontWeight: '450' }}>
                        Enter password
                      </div>
                    </Form.Label>
                    <Form.Control
                      autoFocus
                      type="password"
                      placeholder="Password"
                      onChange={() => setError('')}
                      style={{
                        border: '0.1rem solid black',
                        borderRadius: '0.2rem',
                        height: '2rem',
                        marginLeft: '1rem',
                      }}
                      isInvalid={error.length > 0}
                    />
                  </Form.Group>
                  <Col className="container-label mt-5">
                    <Form.Group className="mb-3" controlId="formConfirmPassword">
                      <Form.Label bsPrefix="" aria-label="Confirm password">
                        <div className="label-text" style={{ fontWeight: '450' }}>
                          Confirm password
                        </div>
                      </Form.Label>
                      <Form.Control
                        autoFocus
                        type="password"
                        placeholder="Password"
                        onChange={() => setError('')}
                        style={{
                          border: '0.1rem solid black',
                          borderRadius: '0.2rem',
                          height: '2rem',
                          marginLeft: '1rem',
                        }}
                        isInvalid={error.length > 0}
                      />
                      <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col xs={8}>
                    By submitting, you agree to the <Link to="/terms">Terms and Conditions</Link>{' '}
                    and <Link to="/privacy">Privacy Policy</Link>
                  </Col>
                  <br />
                  <Row className="justify-content-end">
                    <Col xs="auto" style={{ minWidth: '8rem' }}>
                      <FormButton onClick={handleCreatePassword}>SUBMIT</FormButton>
                    </Col>
                  </Row>
                </Col>
              </Form>
            </Row>
          </Row>
        </Container>
        <p />
      </Modal.Body>
    </Modal>
  );
};

export default SignupModal;
